import { cn } from "../../helpers";
import { paragraph } from "../typography";

const root = cn("flex items-center gap-1 text-red-700");
const icon = cn("w-4 shrink-0");
const text = (className?: string) =>
  cn(
    paragraph({
      size: "xs",
      className: "mt-[1px] block leading-none text-inherit",
    }),
    className,
  );

export { root, text, icon };
